// These are all imaginary so commenting out

import { gql } from "@apollo/client";

export const GET_SHIFTS_FORWARD = gql("{x}") // "{x}" is the smallest syntatically valid gql I could come up with
export const GET_VISITS_FORWARD = gql("{x}")
export const GET_CALENDAR_BLOCKS_FORWARD = gql("{x}")

/**
 * Fetch shifts for capacity calculation
 * Used to calculate available provider time per day
 */
// export const GET_SHIFTS_FORWARD = gql(`
//   query GetShiftsForward($start: String!, $end: String!)
//   @permission(requires: useWebApp)
//   {
//     commandIndexProviders(includeShifts: true, start: $start, end: $end) {
//       providers {
//         id
//         firstName
//         lastName
//         providerType {
//           id
//           name
//         }
//         shifts {
//           id
//           startTime
//           endTime
//           status
//         }
//       }
//     }
//   }
// `);

/**
 * Fetch visits for capacity calculation
 * Used to calculate booked provider time per day
 */
// export const GET_VISITS_FORWARD = gql(`
//   query GetVisitsForward($start: String!, $end: String!)
//   @permission(requires: useWebApp)
//   {
//     visitsByTimespan(start: $start, end: $end) {
//       id
//       startTime
//       endTime
//       eventStatus
//       visitResources {
//         id
//         providerId
//         startTime
//         endTime
//       }
//     }
//   }
// `);

/**
 * Fetch calendar blocks (breaks) for capacity calculation
 * Used to calculate unavailable time within shifts
 */
// export const GET_CALENDAR_BLOCKS_FORWARD = gql(`
//   query GetCalendarBlocksForward($start: String!, $end: String!)
//   @permission(requires: useWebApp)
//   {
//     calendarBlocksByTimespan(start: $start, end: $end) {
//       id
//       providerId
//       startTime
//       endTime
//       blockType
//       eventStatus
//     }
//   }
// `);
